module.exports = __webpack_public_path__ + "img/camera.a1c581a8.svg";